export default function injectDirectives(Vue){
  Vue.directive('focus', {
    inserted: function (el) {
      el.focus()
    }
  });
}
